import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';

import { GET_INVITE } from '../constants';
import { useDeveloperData } from '../providers';
import { getInvite } from '../services';
import { AccountRole, AccountRoles, Invite } from '../types';

export const useUserHasRole = (role: AccountRoles): boolean => {
  const developer = useDeveloperData();
  return developer.role === role;
};

export const useHasOwnerAccess = (): boolean => useUserHasRole(AccountRole.OWNER);

type Options = Omit<UseQueryOptions<Invite, unknown, Invite, string[]>, 'queryKey' | 'queryFn'>;

export const useInvite = (inviteId: string | null, options: Options = {}): UseQueryResult<Invite> =>
  useQuery([GET_INVITE, inviteId], () => getInvite(inviteId as string), {
    ...options,
    enabled: Boolean(inviteId),
  });

export const useHasTeammatesAccess = (): boolean => true;
